export default "__VITE_ASSET__CSOQk3QH__"